import { Filter } from '@selfai-platform/bi-domain';

export function isTimeRangeFilter(filter: Filter): boolean {
  return filter.type === 'time_range';
}
